import { DataSource, Label, Layout, Panel, Tab, Table, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutEdiOrderCarrierPay extends Layout {
    labelBillDistance: Label;
    labelRateDesc: Label;
    labelTotalPay: Label;
    panel1: Panel;
    panelMain: Panel;
    sourceEdiDriverextrapay: DataSource;
    sourceViewEdiOrder: DataSource;
    tabPayAdjustments: Tab;
    tableDriveExtraPay: Table;
    tabsetEdiDriverExtraPay: Tabset;
    textboxCarProNbr: Textbox;
    textboxOverridePayAmt: Textbox;
    textboxOverridePayAmtDisplay: Textbox;
    textboxOverridePayRate: Textbox;
    textboxOverridePayUnits: Textbox;
    textboxOverrideType: Textbox;
    textboxPayAdjustmentTotal: Textbox;
    textboxTotalPay: Textbox;
}
